module.exports = __webpack_public_path__ + "static/avenir-next-bold-08a4b261531ef03ff1cee4abe4302ff4.woff";